<!-- Lyrics Editor Popup -->
<div class="ipm-lyrics-popup">

    <!-- Header Bar -->
    <div class="ipm-beat-info-bar">
        <div class="ipm-img-wrapper" (click)="togglePlayPause()" [class.ipm-is-playing]="isCurrentBeatPlaying">
            <img [src]="beat?.cover_picture" class="ipm-cover" (error)="commonService.errorHandler($event)"
                alt="beat cover" />
            <div class="ipm-img-overlay">
                <i class="pi pi-spin pi-spinner ms-1" *ngIf="isBeatLoading"
                    style="font-size: 1.2rem; margin-top: 4px;"></i>
                <i class="fa fa-play playIcon ms-1" *ngIf="!isCurrentBeatPlaying && !isBeatLoading"></i>
                <i class="fas fa-pause" *ngIf="isCurrentBeatPlaying && !isBeatLoading"></i>
            </div>
        </div>
        <div class="ipm-beat-meta">
            <span class="ipm-beat-title" (click)="goToBeatPage()">{{ beat?.title }}</span>
            <span class="ipm-artist" (click)="goToProducerPage()">
                {{ beat?.producer?.store?.general?.name }}
                <img *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier1'"
                    src="assets/imgs/subs_premium_tick.svg" class="ipm-verify" alt="verified" />
                <img *ngIf="(beat?.producer?.tiers | getSubsTires : 'producer') === 'tier2'"
                    src="assets/imgs/subs_pro_tick_img.png" class="ipm-verify" alt="verified" />
            </span>
        </div>

        <span class="ipm-popup-heading">Lyrics Notebook</span>

        <button class="ipm-close-btn" (click)="closeAndSave()">
            <i class="pi pi-times"></i>
        </button>
    </div>

    <!-- Seekbar Row -->
    <div class="ipm-seekbar-row" *ngIf="playerState.canplay && currentPlayingBeatId === beat?._id">
        <span class="ipm-seek-time">{{ playerState.readableCurrentTime }}</span>
        <mat-slider min="0" [max]="playerState.duration" step="0.01" class="ipm-popup-seekbar"
            [disabled]="playerState.error">
            <input matSliderThumb [(ngModel)]="playerState.currentTime" (dragEnd)="onSeekChange($event)" />
        </mat-slider>
        <span class="ipm-seek-time">{{ playerState.readableDuration }}</span>
    </div>

    <hr class="ipm-separator" />

    <!-- Inline Status Bar (replaces toast notifications) -->
    <div class="ipm-status-bar" *ngIf="statusMessage" [class.ipm-status-success]="statusType === 'success'"
        [class.ipm-status-error]="statusType === 'error'" [class.ipm-status-info]="statusType === 'info'">
        <i class="pi pi-check-circle" *ngIf="statusType === 'success'"></i>
        <i class="pi pi-exclamation-circle" *ngIf="statusType === 'error'"></i>
        <i class="pi pi-info-circle" *ngIf="statusType === 'info'"></i>
        <span>{{ statusMessage }}</span>
        <i class="pi pi-times ipm-status-dismiss" (click)="dismissStatus()"></i>
    </div>

    <div class="ipm-lyric-body" *ngIf="!isLoading">

        <div class="ipm-version-sidebar">
            <div class="ipm-version-capsule ipm-add-version-capsule" *ngIf="versions.length < MAX_VERSIONS"
                (click)="createNewVersion()">
                <i class="pi pi-plus"></i>
                <span class="ipm-capsule-title">Add Version</span>
            </div>

            <div class="ipm-version-capsule" *ngFor="let v of versions" [class.ipm-active]="v.version === activeVersion"
                [class.ipm-confirming-delete]="versionToDelete === v.version" (click)="switchVersion(v.version)">

                <!-- Normal capsule content -->
                <ng-container *ngIf="versionToDelete !== v.version">
                    <span class="ipm-capsule-title">{{ v.title || 'Untitled' }}</span>
                    <img src="https://ip-dev.s3.ap-south-1.amazonaws.com/Platform+Graphics/Resources/dustbin.svg"
                        alt="delete" width="13" height="13" class="ipm-icon-white ipm-delete-icon"
                        (click)="requestDeleteVersion(v.version, $event)" />
                </ng-container>

                <!-- Inline delete confirmation -->
                <ng-container *ngIf="versionToDelete === v.version">
                    <span class="ipm-confirm-text">Delete?</span>
                    <button class="ipm-confirm-yes" (click)="confirmDelete(v.version, $event)" [disabled]="isDeleting">
                        <i class="pi pi-spin pi-spinner" *ngIf="isDeleting"></i>
                        <span *ngIf="!isDeleting">Yes</span>
                    </button>
                    <button class="ipm-confirm-no" (click)="cancelDelete($event)">No</button>
                </ng-container>
            </div>
        </div>

        <!-- Lyrics Editor -->
        <div class="ipm-lyric-editor">
            <div class="ipm-editor-header">
                <span class="ipm-version-label">{{ getActiveVersion()?.title || 'Untitled' }}</span>
            </div>

            <div class="ipm-title-field">
                <input type="text" [(ngModel)]="currentTitle" (input)="onTitleInput()" placeholder="Enter title..."
                    [maxlength]="MAX_TITLE_CHARS" class="ipm-title-input" />
                <span class="ipm-title-char-count">
                    {{ currentTitle.length }} / {{ MAX_TITLE_CHARS }}
                </span>
            </div>

            <!-- Lyrics textarea -->
            <textarea #lyricsTextarea [(ngModel)]="currentLyricsText" (input)="onLyricsInput($event)"
                (click)="onCursorMove($event)" (keyup)="onCursorMove($event)" class="ipm-lyrics-textarea"
                placeholder="Start writing your lyrics..." [maxlength]="MAX_LYRICS_CHARS" spellcheck="false"></textarea>

            <!-- Last updated (left) + Char counter (right) — same line -->
            <div class="ipm-lyrics-meta-row">
                <span class="ipm-last-updated" *ngIf="activeLastModified">
                    Last Updated: {{ activeLastModified }}
                </span>
                <span class="ipm-lyrics-char-count" *ngIf="currentLyricsText.length > 0">
                    {{ currentLyricsText.length | number }} / {{ MAX_LYRICS_CHARS | number }}
                </span>
            </div>

            <!-- Footer: Auto-save + Download + Save -->
            <div class="ipm-editor-footer">
                <div class="ipm-auto-save-section">
                    <div class="ipm-custom-checkbox ipm-auto-save-toggle">
                        <p-checkbox [(ngModel)]="autoSaveEnabled" [binary]="true"
                            inputId="autoSaveCheckbox"></p-checkbox>
                        <label for="autoSaveCheckbox">Auto-save</label>
                    </div>
                    <span class="ipm-auto-save-status" *ngIf="autoSaveEnabled">
                        <ng-container *ngIf="autoSaveStatus === 'saving'">
                            <i class="pi pi-spin pi-spinner"></i> Saving...
                        </ng-container>
                        <ng-container *ngIf="autoSaveStatus === 'saved'">
                            <i class="pi pi-check"></i> Saved
                        </ng-container>
                        <ng-container *ngIf="autoSaveStatus === 'error'">
                            <i class="pi pi-exclamation-triangle"></i> Save failed
                        </ng-container>
                    </span>
                </div>
                <div class="ipm-footer-actions">
                    <button class="ipm-download-btn" title="Download" (click)="downloadLyrics()">
                        <i class="pi pi-download"></i> Download
                    </button>
                    <button class="ipm-save-btn" (click)="saveLyrics()" [disabled]="isSaving">
                        <i class="pi pi-spin pi-spinner" *ngIf="isSaving"></i>
                        Save Lyrics
                    </button>
                </div>
            </div>
        </div>

        <!-- RIGHT: Rhyme Panel -->
        <div class="ipm-rhyme-panel">
            <h3>Rhyme suggestion</h3>

            <!-- Manual search bar -->
            <div class="ipm-rhyme-search">
                <input type="text" placeholder="Search rhymes..." [(ngModel)]="rhymeSearchWord"
                    (input)="onRhymeSearchInput()" class="ipm-rhyme-input" />
            </div>

            <!-- Auto-search toggle -->
            <div class="ipm-custom-checkbox ipm-auto-search">
                <p-checkbox [(ngModel)]="autoSearchEnabled" [binary]="true" inputId="autoSearchCheckbox"></p-checkbox>
                <label for="autoSearchCheckbox">Auto search while writing</label>
            </div>

            <hr class="ipm-separator" />

            <!-- Lottie searching animation -->
            <div class="ipm-rhyme-lottie" *ngIf="isSearchingRhymes">
                <ng-lottie [options]="rhymeLoaderOptions"></ng-lottie>
                <span class="ipm-searching-text">Searching rhymes...</span>
            </div>

            <!-- Rhyme results -->
            <div class="ipm-rhyme-results" *ngIf="rhymeData && !isSearchingRhymes">
                <div class="ipm-rhyme-section" *ngIf="rhymeData.primary?.length">
                    <h4>Primary</h4>
                    <div class="ipm-rhyme-words">
                        <span *ngFor="let r of rhymeData.primary" (click)="insertRhyme(r.word)">{{ r.word }}</span>
                    </div>
                </div>
                <div class="ipm-rhyme-section" *ngIf="rhymeData.secondary?.length">
                    <h4>Secondary</h4>
                    <div class="ipm-rhyme-words">
                        <span *ngFor="let r of rhymeData.secondary" (click)="insertRhyme(r.word)">{{ r.word }}</span>
                    </div>
                </div>
                <div class="ipm-rhyme-section" *ngIf="rhymeData.freestyle?.length">
                    <h4>Freestyle</h4>
                    <div class="ipm-rhyme-words">
                        <span *ngFor="let r of rhymeData.freestyle" (click)="insertRhyme(r.word)">{{ r.word }}</span>
                    </div>
                </div>
            </div>

            <!-- Hint when no results -->
            <p *ngIf="!rhymeData && !isSearchingRhymes" class="ipm-rhyme-hint">
                Type a word above or enable auto-search to see rhyme suggestions
            </p>
        </div>

    </div>

    <!-- Loading state -->
    <div class="ipm-loading-state" *ngIf="isLoading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading lyrics...</span>
    </div>

</div>